import { render, staticRenderFns } from "./StandingsRoundDataPane.vue?vue&type=template&id=61c0d3b4&scoped=true"
import script from "./StandingsRoundDataPane.vue?vue&type=script&lang=ts"
export * from "./StandingsRoundDataPane.vue?vue&type=script&lang=ts"
import style0 from "./StandingsRoundDataPane.vue?vue&type=style&index=0&id=61c0d3b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c0d3b4",
  null
  
)

export default component.exports